<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          Messenger execution log
        </h6>
      </div>

      <div class="element-box">
        <h5 class="form-header mb-4">
          Messenger execution log list
        </h5>

        <Search
            class="mb-3"
            :filters="filters"
            :loading="isSearching"
            :statusDropdown="statusDropdown"
            @search="getMessengerExecutionLogList"/>

        <PerPage :values="[10, 25, 50, 100]" @update:perPage="getMessengerExecutionLogList"/>

        <div class="table-responsive overflow-auto pt-4">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>
                <a href="#" @click="sortBy('createdAt')">
                  <span>Created at</span>
                  <i :class="getIconClass('createdAt')"></i>
                </a>
              </th>
              <th>
                <a href="#" @click="sortBy('messageType')">
                  <span>Message type</span>
                  <i :class="getIconClass('messageType')"></i>
                </a>
              </th>
              <th>
                <a href="#" @click="sortBy('status')">
                  <span>Status</span>
                  <i :class="getIconClass('status')"></i>
                </a>
              </th>
              <th>Private coaching</th>
              <th>Message</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(log) in messengerExecutionLogList.data" :key="log.id">
              <td>{{ log?.createdAt }}</td>
              <td>{{ log?.messageType }}</td>
              <td>{{ log?.status }}</td>
              <td>{{ log?.privateCoachingId }}</td>
              <td class="text-truncate" style="max-width: 350px;">{{ log?.message }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <Pagination
            v-if="messengerExecutionLogList?.pagination?.total_pages > 1"
            :totalPages="messengerExecutionLogList?.pagination?.total_pages"
            :currentPage="messengerExecutionLogList?.pagination?.current_page"
            :totalItems="messengerExecutionLogList?.pagination?.total_items"
            :perPage="messengerExecutionLogList?.pagination?.items_per_page"
            @pagechanged="getMessengerExecutionLogList"/>
      </div>
    </div>
  </PageTemplate>
</template>


<script setup>
import systemMonitoringService from '@/api/SystemMonitoring';
import Pagination from '@/components/Pagination.vue';
import {CloseToast, ErrorToast} from '@/components/VueToast';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import PerPage from '@/components/PerPage.vue';
import {onMounted, ref} from 'vue';
import Search from "@/views/App/SystemMonitoring/MessengerExecutionLog/Search.vue";
import {getSortIconClass} from '@/shared/functions';

const messengerExecutionLogList = ref([]);
const isSearching = ref(false);
const isLoaded = ref(false);

const filters = ref({
  messageType: '',
  status: '',
  privateCoachingId: '',
  dateFrom: '',
  dateTo: '',
  searchTerm: '',
  sortBy: 'createdAt',
  orderBy: 'DESC',
});

const statusDropdown = ref([
  {value: 'success', label: 'Success'},
  {value: 'failed', label: 'Failed'},
]);

function getIconClass(key) {
  return getSortIconClass(filters.value, key);
}

function sortBy(key) {
  filters.value = {
    ...filters.value,
    sortBy: key,
    orderBy: filters.value.orderBy === 'DESC' || filters.value.sortBy !== key ? 'ASC' : 'DESC',
  };
  getMessengerExecutionLogList();
}

async function getMessengerExecutionLogList(page = 1, perPage, passedFilters) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = messengerExecutionLogList.value?.pagination?.items_per_page;

  try {
    const {data} = await systemMonitoringService.getMessengerExecutionLogs({
      page: page,
      limit: perPage ?? perPageRes,
      ...(passedFilters ? passedFilters : filters.value),
    });

    messengerExecutionLogList.value = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

onMounted(async () => {
  await getMessengerExecutionLogList()
  isLoaded.value = true;
});

</script>

<style scoped>

</style>
